import { render, staticRenderFns } from "./ValuerInsightsBlock.vue?vue&type=template&id=c2194e2a&scoped=true&"
import script from "./ValuerInsightsBlock.vue?vue&type=script&lang=ts&"
export * from "./ValuerInsightsBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ValuerInsightsBlock.vue?vue&type=style&index=0&id=c2194e2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2194e2a",
  null
  
)

export default component.exports